module.exports = __webpack_public_path__ + "img/design_2.27d3d1c0.svg";